export const addressFromCoordinates = (
	geocoder: google.maps.Geocoder,
	location: google.maps.LatLngLiteral | google.maps.LatLng | undefined | null
): Promise<string | void> => {
	return geocoder.geocode({ location }).then((response) => response.results[0]?.formatted_address)
}
